import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '../../core';
import { ChatPanelService } from '../../domains/aya/services/chat-panel.service';

@Component({
  selector: 'sgt-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  hasChatAccess = false;
  isOnChatPage = false;

  @Input() isSidebarMini = true;
  @Output() toggleSidebar = new EventEmitter<boolean>();

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private authService: AuthService,
    private chatPanelService: ChatPanelService,
  ) {}

  ngOnInit() {
    this.hasChatAccess = this.authService.canAccessAIPage();
    this.isOnChatPage = this.isAyaRoute(this.router.url);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe((event) => {
        this.isOnChatPage = this.isAyaRoute(event.url);
      });
  }

  toggleSidebarClick() {
    this.isSidebarMini = !this.isSidebarMini;
    this.toggleSidebar.emit(this.isSidebarMini);
  }

  toggleChat() {
    this.chatPanelService.toggle();
  }

  private isAyaRoute(url: string): boolean {
    return url.includes('/ceppem-ai');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
